module.exports = __webpack_public_path__ + "assets/img/intro-vip-a2.0678e96c.jpg";